import { render } from "./preFetch.vue?vue&type=template&id=145715eb"
import script from "./preFetch.vue?vue&type=script&lang=js"
export * from "./preFetch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__